import { RokezzzPlatformService } from 'src/app/rokezzz/platform/services/platform.service';
import { CookieSettings } from '../api/cookie-settings';
import { RokezzzCookieService } from './../../rokezzz/cookies/services/cookie.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CookieAcceptanceService {
    private readonly cookieSettingKey: string = 'cookie-settings';

    public isCookiePopupVisible: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public isCookieDetailsPopupVisible: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    public constructor(
        private readonly cookieService: RokezzzCookieService,
        private readonly platformService: RokezzzPlatformService
    ) { }

    public showCookieDetailsPopup(): void {
        this.isCookiePopupVisible.next(false);
        this.isCookieDetailsPopupVisible.next(true);
    }

    public showCookiePopup(): void {
        this.isCookieDetailsPopupVisible.next(false);
        this.isCookiePopupVisible.next(true);
    }

    public isCookieSettings(): boolean {
        return !!this.cookieService.get(this.cookieSettingKey);
    }

    public setCookieSetting(cookie: CookieSettings): void {
        this.cookieService.set(this.cookieSettingKey, JSON.stringify(cookie), 365);
    }

    public setAllCookieSettings(): void {
        this.cookieService.set(this.cookieSettingKey, JSON.stringify({
            preferences: true,
            statistics: true,
            marketing: true,
            functionality: true
        }), 365);
    }

    public declineAllCookieSettings(): void {
        this.cookieService.set(this.cookieSettingKey, JSON.stringify({
            preferences: false,
            statistics: false,
            marketing: false,
            functionality: true
        }), 365);
    }

    public removeAllSettingsKeys(): void {
        this.cookieService.delete(this.cookieSettingKey);
    }

    public getCookieSettings(): CookieSettings {
        if (this.platformService.isPlatformServer()) {
            return {
                preferences: false,
                statistics: false,
                marketing: false,
                functionality: true
            };
        }

        const settings: string | null = this.cookieService.get(this.cookieSettingKey);

        return settings ? JSON.parse(settings) : {
            preferences: false,
            statistics: false,
            marketing: false,
            functionality: true
        };
    }
}
